import { UIHeading5 } from '@cian/ui-kit';

import styles from './InlineFilterSection.css';
import { FC, PropsWithChildren } from 'react';

interface IFilterSectionProps {
  title: string | null;
  dataTestId?: string;
}

export const InlineFilterSection: FC<PropsWithChildren<IFilterSectionProps>> = ({ title, children, dataTestId }) => {
  return (
    <div className={styles['section']} data-testid={dataTestId}>
      {title && (
        <div className={styles['title']}>
          <UIHeading5>{title}</UIHeading5>
        </div>
      )}
      <div className={styles['content']}>{children}</div>
    </div>
  );
};
